import { Box, Button, Typography } from "@mui/material";
import { HankoSecondaryCard } from "./HankoSecondaryCard";
import { Price } from "../../models/Subscription";
import { Add } from "@mui/icons-material";

interface Props {
  onClickFunc: () => void,
  price?: Price
}

const NewProjectsCard = (props: Props) => {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: props.price?.currency ?? "USD"
  })

  return (
    window.REACT_APP_DISABLE_PROJECT_CREATION ?
      <HankoSecondaryCard>
        <Typography variant="body1">Project creation is temporarily disabled due to maintenance.</Typography>
        <Button sx={{width: 'fit-content', marginLeft: 'auto'}} variant="contained" onClick={props.onClickFunc} disabled>Create
          project</Button>
      </HankoSecondaryCard> :
      <HankoSecondaryCard>
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
          <Add height="28px" width="28px" sx={{ height: '28px', width: '28px', border: '1.18px solid #262B35', borderRadius: '4.71px' }}/>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>Create a new project</Typography>
        </Box>
        <Box sx={{width: '100%', justifyContent: 'space-between', display: 'flex', gap: 1, alignItems: 'center'}}>
          <Typography sx={{ fontWeight: 500 }}>{props.price !== undefined ? currencyFormatter.format(props.price.amount / 100) + " / month" : null}</Typography>
        <Button sx={{width: 'fit-content'}} variant="contained" onClick={props.onClickFunc}>Create
          project</Button>
        </Box>
      </HankoSecondaryCard>
  )
}

export default NewProjectsCard